import { NgModule } from "@angular/core";
import { FileValidator } from "./file-validator.service";

@NgModule({
    providers: [FileValidator],
})
export class FileValidatorModule {}
